module.exports = __webpack_public_path__ + "img/toplogo.f9047c77.png";